import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { defaultFilter as customRolesDefaultFilter } from '@views/CustomRoles/utils';
import { PAGE_PATHS, Permission } from '../../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/')({
  validateSearch: zodValidator(withDefaults(schema.EDIT_CUSTOM_ROLES, customRolesDefaultFilter, defaultFilter)),
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.ROLES }) ||
      !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.ROLES, permission: Permission.UPDATE });
    context.validatePermissions({ isAllowed, preload });
  },
});
